import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ColorPickerModule } from 'ngx-color-picker';
import { BackgroundColorDialogComponent } from './background-color-dialog.component';



@NgModule({
  declarations: [
    BackgroundColorDialogComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    SharedModule,
    ReactiveFormsModule,
    ColorPickerModule
  ],
  exports: [
    BackgroundColorDialogComponent
  ],
  entryComponents: [
    BackgroundColorDialogComponent
  ]
})
export class BackgroundColorDialogModule { }
